import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as LinkIcon } from './link.svg';

export const Link = IconHOC(LinkIcon);
